export const TXTCLI_Email_address_is_not_valid = {
  "id": "TXTCLI_Email_address_is_not_valid",
  "defaultMessage": "Email address is not valid"
} as const;